import { c as _c } from "react/compiler-runtime";
import type { TextMessage } from "@/types/agent/message";
import { parseMarkdown } from "@/lib/utils/parseInlineMarkdown";
import { SpeechBubble } from "./SpeechBubble";
interface AgentTextMessageProps {
  message: TextMessage;
}
export const AgentTextMessage: React.FC<AgentTextMessageProps> = t0 => {
  const $ = _c(4);
  const {
    message
  } = t0;
  let t1;
  if ($[0] !== message.content) {
    t1 = parseMarkdown(message.content);
    $[0] = message.content;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <SpeechBubble sender="assistant">{t1}</SpeechBubble>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};